import * as React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/variables';
import { ICurrency } from '../ShoppingCart/types';
import { priceWithCommas } from '../utils/commonHelper';
import { getLocale } from '../utils/pathHelper';

const PriceView = styled.div`
  margin: 0.2em 0;
  line-height: 1.2em;
  text-align: right;
  & > .discount {
    margin-bottom: 0.1em;
    .discount-rate {
      font-size: 0.6em;
      font-weight: bold;
      background-color: ${colors.red};
      padding: 0.1em 0.5em;
      border-radius: 0.2em;
      color: ${colors.white};
    }
    .full-price {
      font-size: 0.7em;
      color: ${colors.red};
      text-decoration: line-through;
      margin-left: 0.4em;
    }
  }
  & > .price-container {
    & > div {
      display: inline-block;
    }
    .currency {
      font-size: 0.7em;
      color: ${colors.gray600};
      margin-right: 0.2em;
    }
    .amount {
      font-size: 1.2em;
      font-weight: bold;
      &.strike {
        text-decoration: line-through;
      }
    }
    .strike {
      text-decoration: line-through;
    }
  }
`;

interface IPriceProps {
  isStrikeThrough?: boolean;
  price: number;
  fullPrice?: number;
  showDiscount?: boolean;
  fontSize?: number;
  style?: any;
  localCurrency?: ICurrency;
  showJPY?: boolean;
  wavyLine?: boolean;
}


const Price: React.FC<IPriceProps> = ({
  isStrikeThrough, price, fullPrice, showDiscount, fontSize, style, localCurrency, showJPY = true, wavyLine = false
  }) => {
  const locale = getLocale({ underscore: true });
  const styling = { ...style, fontSize: fontSize ? fontSize : 16 }
  const discountRate = fullPrice ? Math.floor((fullPrice - price) / fullPrice * 100) : 0;
  const fullPriceCurrencies: { code: string, fullPrice: number }[] = [{ code: 'JPY', fullPrice }]
  const { rate } = localCurrency;
  if (rate != null) {
    fullPriceCurrencies.push({
      code: localCurrency.code,
      fullPrice: Math.round(fullPrice * rate),
    });
  }

  if (locale.toString() == 'ja') {
    return (
      <PriceView style={styling}>
        {(!!fullPrice && showDiscount && discountRate > 0) &&
          <div className="discount">
            <span className="discount-rate">{discountRate}%OFF</span>
            {showJPY &&
              <span className="full-price">
                {priceWithCommas(fullPrice)}円
              </span>
            }
          </div>
        }
        <div className="price-container">
          {showJPY &&
            <div>
              <span className={`amount ${isStrikeThrough && 'strike'}`}>{priceWithCommas(price)}<span className="currency">円</span>{wavyLine ? "〜" : ""}</span>
          </div>}
        </div>
      </PriceView>
    );
  } else {
    return (
      <PriceView style={styling}>
        {(!!fullPrice && showDiscount && discountRate > 0) &&
          <div className="discount">
            <span className="discount-rate">{discountRate}%OFF</span>
            {showJPY &&
              <span className="full-price">
                JPY {Math.round(fullPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </span>
            }
          </div>
        }
        <div className="price-container">
          {showJPY &&
            <div>
              <span className="currency">JPY</span>
              <span className={`amount ${isStrikeThrough && 'strike'}`}>{Math.round(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{wavyLine ? "〜" : ""}</span>
          </div>}
          {!!rate &&
            <div style={{ marginLeft: '0.4em' }}>
              <span className="currency">{localCurrency.code}</span>
              <span className={`${isStrikeThrough && 'strike'}`}>{priceWithCommas(price * rate)}{wavyLine ? "〜" : ""}</span>
          </div>}
        </div>
      </PriceView>
    );
  }
  }

export default Price;
